import script from "./RBPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./RBPopup.vue?vue&type=script&setup=true&lang=js"

import "./RBPopup.vue?vue&type=style&index=0&id=656a0b1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-656a0b1e"]])

export default __exports__